import React from 'react';
import { ShieldAlert } from 'lucide-react';

export const AdminForbidden = ({ user, onLogout }) => (
  <div className="min-h-screen bg-dark flex items-center justify-center px-6" data-testid="admin-forbidden">
    <div className="max-w-md text-center">
      <ShieldAlert className="w-12 h-12 text-gold mx-auto mb-6" />
      <h1 className="text-3xl font-playfair text-white mb-3">Accès réservé</h1>
      <p className="text-gray-400 mb-8">Le compte <span className="text-gold">{user.email}</span> n'a pas accès au tableau de bord administrateur. Retrouvez vos projets dans votre espace client.</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <a href="/mon-espace" data-testid="forbidden-go-client-space" className="bg-gold hover:bg-gold-light text-dark font-semibold px-6 py-3 transition-colors">Mon espace</a>
        <button type="button" onClick={onLogout} data-testid="forbidden-logout" className="border border-white/20 text-gray-300 hover:border-gold hover:text-gold px-6 py-3 transition-colors">Changer de compte</button>
      </div>
    </div>
  </div>
);
